let devMode,
	mobileCheck,
	pageTransition,
	pageTransitionEnabled = false,
	resizeCallbacks = [],
	mapMaker,
	loadScript,
	mobileResizeCallbacks = [],
	navigation,
	smoother;

window.initMap = function(){
	document.addEventListener("DOMContentLoaded", function () {
		window.dispatchEvent(new Event('googleMapApiLoaded'));
	});
};

document.addEventListener("DOMContentLoaded", function () {
	new StarterKitMcube();
	// Composants Mobile & Desktop

	new PagesHome();
	new PagesRealisation();
	new PagesSingleNews();

	// new RadialBackgroundAnimation();
	new Buttons();
	navigation = new Navigation();
	new ImageReveal();
	new ImageScrollReveal();

	new RiveAnimation();
	new RiveAnimationRange();

	new BlockBattery();
	new BlockGallery();
	new BlockKeyNumbersImage();
	new BlockRange();
	new BlockSliderHorizontal();
	new BlockSliderVertical();
	new BlockSav();
	new BlockThreeLinks();

	new ctaFixed();

	if (mobileCheck.isMobile) {
		// Composants Mobile uniquement
	} else {
		new Cursor();
	}
});
